import axios from "axios";
import {INAICS} from "./NAICS.types";

export default class NAICSApi {

    static async searchNaicsCodes(queryString:string){
        try {
            let res = await axios.get(`/naics?${queryString}`);
            if (res){
                return res.data as INAICS[];
            }
        } catch (e) {
            console.error('Error getting naics codes', e.message);
            return undefined;
        }
    }

}